import React from "react";
import { Box, BoxProps, Typography } from "@material-ui/core";

const List: React.FC = ({ children, ...rest }) => (
  <Box component="ul" pl={2} mt={0} mb={0.5} {...rest}>
    {children}
  </Box>
);
const ListItem: React.FC<{ dense?: boolean }> = ({
  dense = false,
  children,
  ...rest
}) => (
  <Box component="li" mt={dense ? 0 : 1} {...rest}>
    <Typography component="span">{children}</Typography>
  </Box>
);

export type TextListProps = {
  dense?: boolean;
} & BoxProps;
export const TextList: React.FC<TextListProps> = ({
  dense = false,
  children,
  ...props
}) => {
  if (!React.Children.count(children)) return null;

  return (
    <List {...props}>
      {React.Children.map(children, (child) => {
        const {
          props: { children, ...other },
        } = child as React.ReactElement;
        return (
          <ListItem dense={dense} {...other}>
            {children}
          </ListItem>
        );
      })}
    </List>
  );
};
